import { createSlice } from "@reduxjs/toolkit";
import { ApiConfigs } from "./configs.entity";
import { getConfigThunk } from "./configs.thunk";
import { defaultConfig } from "./configs.default";

export interface ConfigsStore {
  configs: ApiConfigs;
}

export const InitialConfigsState: ConfigsStore = {
  configs: defaultConfig,
};

const ConfigsSlice = createSlice({
  name: "ConfigsSlice",
  initialState: InitialConfigsState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getConfigThunk.fulfilled, (state, action) => {
      if (action.payload) {
        state.configs = action.payload;
      }
    });
  },
});

export const ConfigsActions = ConfigsSlice.actions;
export const ConfigsReducer = ConfigsSlice.reducer;
